import React, { Fragment, useState, useRef } from 'react';
import { Listbox, Transition } from '@headlessui/react';
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid';



const ListBox = ({
  options,
  defaultValue,
  onChange,
  required,
  placeholder = { name: 'Seleziona', value: '' },
  openDirection = 'up',
  positionOptions = 'absolute',
  wrapperClassName = '',
}) => {
  const [selected, setSelected] = useState(defaultValue || placeholder || options[0]);
  const listBoxRef = useRef(null);

  const handleButtonClick = () => {
    if (listBoxRef.current) {
      listBoxRef.current.click();
    }
  };

  const listBoxStyles = {
    bottom: openDirection === 'down' ? '100%' : 'auto',
    top: openDirection === 'up' ? '100%' : 'auto',
  };

  return (
    <div>
      <Listbox value={selected} onChange={(value) => { setSelected(value); onChange && onChange(value); }}>
        <div className="relative mt-1">
          <Listbox.Button
            className={`relative h-10 mt-0.5 w-full cursor-default rounded-md bg-white py-2 pl-3 pr-10 text-left shadow-md focus:outline-none  sm:text-sm border border-gray-300 focus:ring-indigo-400 focus:border-indigo-400 focus:border-2 ${wrapperClassName} ${
              required ? 'required' : ''
            }`}
            onClick={handleButtonClick}
          >
            <span className="block truncate">{selected ? selected.name : placeholder.name}</span>
            <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
              <ChevronUpDownIcon className="h-5 w-5 text-gray-400" />
            </span>
          </Listbox.Button>
          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Listbox.Options
              ref={listBoxRef}
              className={`${positionOptions} mt-1 w-full max-h-[30vh] overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm z-30`}
              style={{ ...listBoxStyles }}
            >
              {options.map((option, idx) => (
                <Listbox.Option
                  key={idx}
                  className={({ active }) =>
                    `relative cursor-default select-none py-2 pl-10 pr-4 ${active ? 'bg-indigo-100 text-gray-900' : 'text-gray-900'}`
                  }
                  value={option}
                >
                  {({ selected }) => (
                    <>
                      <span className={`block whitespace-normal break-words ${selected ? 'font-medium' : 'font-normal'}`}>{option.name}</span>
                      {selected ? (
                        <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-indigo-800">
                          <CheckIcon className="h-5 w-5" />
                        </span>
                      ) : null}
                    </>
                  )}
                </Listbox.Option>
              ))}
            </Listbox.Options>
          </Transition>
        </div>
      </Listbox>
    </div>
  );
};

export default ListBox;